import React from 'react';
import '../Styles/WhyUs.css';

const WhyUs = () => {
  return (
    <div className="why-us-container">
        <div className='why-us-content-box'>
            
            <div className='why-us-content-box-Heading-section'>
                <h1 className='why-us-content-box-Heading-section-h1'>
                    Why Us?
                </h1>
                <p className='why-us-content-box-Heading-section-p'>
                    Prasiddh blends luxury living with smart investment. 
                    Unlike unregulated farmland plots, it’s a fully developed eco-village with curated villas and resort amenities. 
                    With the resort operating inside the community, land value appreciates faster—and villa owners benefit from steady rental returns through profit-sharing.
                </p>
            </div>

            <h1 className='why-us-main-h1'><span className='why-us-main-h1-span'>Prasiddh</span> vs Other Projects</h1>

            <div className='why-us-comparison-table'>
                <div class="why-us-scroll-content">
                
                <div className='why-us-comparison-table-th'> 
                    <div className='why-us-comparison-table-th-1'>
                        Feature / Parameter
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-th-2'>
                        Prasiddh
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-th-3'>
                        Typical Farmland Projects
                    </div>
                </div>
                
                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        Legal Status
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                         ✔ Under the approval of STRR, DC Converted,
                          will compliant with legal norms, all 
                          approvals and plan sanctions including 
                          building plan.
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌ Mostly agricultural land, often 
                        not converted or legally approved 
                        for residential use 
                    </div>
                </div>
                
                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        Project Readiness
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                         ✔ Ready-to-move-in villas with 
                        completed infrastructure and 
                        luxury finish
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                          ❌  Raw land with minimal or no 
                        development, buyers must wait 
                        or self-develop 
                    </div>
                </div>
                
                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                         Thematic Design
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔  Inspired by Balinese luxury with 
                        curated vegetation, water features, 
                        and aesthetic landscaping
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌ Basic plot divisions with no 
                        thematic or aesthetic planning      
                    </div>
                </div>
                
                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                         Community Living
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔ Designed as a complete living 
                        community with amenities for 
                        seniors, adults, and children
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌  Lacks integrated community 
                        planning; often isolated and not 
                        suited for daily residential living      
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        Amenities & Infrastructure
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔ Senior-friendly pathways, 
                            kids’ play areas, fitness 
                            zones, clubhouse, meditation 
                            lawns, jogging tracks, etc. 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌  Little to no infrastructure; 
                                amenities, if any, are often 
                                basic and not professionally 
                                maintained      
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        Open Space Ratio 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔ Over 2/3 of land 
                            dedicated to open space, 
                            nature, and green buffers
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌   Limited or no planned 
                            open space; often maximized 
                            for saleable land     
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        Target Audience 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔ Built for lt for es, and 
                            nature-loving individuals 
                            looking for peaceful, luxurious 
                            living 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌   Primarily for speculative 
                            buyers or weekend farmers         
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        Utility & Maintenance  
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔ Ready connections for 
                            electricity, water, sewage, 
                            with a well-managed 
                            maintenance plan 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌   Often lacking basic 
                            services; individual buyers 
                            bear the burden of setup and 
                            maintenance         
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        Resale and Appreciation Potential  
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔  High – due to clear legal 
                            titles, theme-based 
                            development, and livable 
                            infrastructure
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌   Risky – appreciation tied 
                            to uncertain development and 
                            legal issues        
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        * Building plan approval   
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔  Construction Plan with Floor 
                            wise permissions approved 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌   Unavailable, have to 
                            individually get the approvals        
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        * Water resource management 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔  DEWATS - One of the Best 
                            Water Treatment System 
                            managed by CDD 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌   No efforts or very minimal 
                            Infra in Water resources 
                            management       
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        * Sewage and Drainage 
                            concept which is design in 
                            PRASIDDH is best of 
                            anyone 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔  Best system in drainage 
                            facility enables minimal 
                            disruption and very less 
                            maintenance 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌    Often lacking basic 
                            services; individual buyers 
                            bear the burden of setup and 
                            Maintenance        
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        * KEB power sanction
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔  Have Proper Sanction and All 
                            electric Capabilities 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌ Individual buyers bear the 
                            burden of applying for 
                            santions        
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        * Uniform Construction 
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔  Having Executed via experts 
                            uniformly over the entire 
                            community, gives Aesthetic 
                            Looks and Elegance, making 
                            up for great community sense  
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌ Adhoc, very individualistic 
                            and inconsistent community 
                            or a feeling of non-community       
                    </div>
                </div>

                <div className='why-us-comparison-table-td'> 
                    <div className='why-us-comparison-table-td-1'>
                        * Boundary Compound wall 
                            done in PRASIDDH is 
                            unique  
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-2'>
                          ✔   7 feet Boundary walls right 
                            walls make Prasiddh unique 
                            and Secured.  
                    </div>
                    <div className='table-colum-line'></div>
                    <div className='why-us-comparison-table-td-3'>
                         ❌Seldom have solid 
                            compound in most of them. 
                            Living the safety to wind.        
                    </div>
                </div>

                </div>
            </div>

        </div>
    </div>
  );
};

export default WhyUs;
